/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendFreshnessResponseDto } from '../models/backend-freshness-response-dto';
import { getFreshnessFreshnessGet } from '../fn/system/get-freshness-freshness-get';
import { GetFreshnessFreshnessGet$Params } from '../fn/system/get-freshness-freshness-get';
import { healthHealthGet } from '../fn/system/health-health-get';
import { HealthHealthGet$Params } from '../fn/system/health-health-get';
import { BackendHealthResponseDto } from '../models/backend-health-response-dto';
import { BackendReadinessResponseDto } from '../models/backend-readiness-response-dto';
import { readyReadyGet } from '../fn/system/ready-ready-get';
import { ReadyReadyGet$Params } from '../fn/system/ready-ready-get';
import { BackendVersionResponseDto } from '../models/backend-version-response-dto';
import { versionVersionGet } from '../fn/system/version-version-get';
import { VersionVersionGet$Params } from '../fn/system/version-version-get';

@Injectable({ providedIn: 'root' })
export class BackendApiSystemService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `healthHealthGet()` */
  static readonly HealthHealthGetPath = '/health';

  /**
   * Проверка живости сервиса (liveness).
   *
   * Лёгкий liveness-check без внешних зависимостей.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `healthHealthGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  healthHealthGet$Response(
    params?: HealthHealthGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendHealthResponseDto>> {
    return healthHealthGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Проверка живости сервиса (liveness).
   *
   * Лёгкий liveness-check без внешних зависимостей.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `healthHealthGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  healthHealthGet(params?: HealthHealthGet$Params, context?: HttpContext): Observable<BackendHealthResponseDto> {
    return this.healthHealthGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendHealthResponseDto>): BackendHealthResponseDto => r.body),
    );
  }

  /** Path part for operation `versionVersionGet()` */
  static readonly VersionVersionGetPath = '/version';

  /**
   * Версия сервиса.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `versionVersionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionVersionGet$Response(
    params?: VersionVersionGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendVersionResponseDto>> {
    return versionVersionGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Версия сервиса.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `versionVersionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionVersionGet(params?: VersionVersionGet$Params, context?: HttpContext): Observable<BackendVersionResponseDto> {
    return this.versionVersionGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendVersionResponseDto>): BackendVersionResponseDto => r.body),
    );
  }

  /** Path part for operation `readyReadyGet()` */
  static readonly ReadyReadyGetPath = '/ready';

  /**
   * Проверка готовности сервиса (readiness).
   *
   * Проверяет доступность master-БД и service-БД через `SELECT 1`. Возвращает 200, если все проверки прошли, 503 если хоть одна упала.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `readyReadyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  readyReadyGet$Response(
    params?: ReadyReadyGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendReadinessResponseDto>> {
    return readyReadyGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Проверка готовности сервиса (readiness).
   *
   * Проверяет доступность master-БД и service-БД через `SELECT 1`. Возвращает 200, если все проверки прошли, 503 если хоть одна упала.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `readyReadyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  readyReadyGet(params?: ReadyReadyGet$Params, context?: HttpContext): Observable<BackendReadinessResponseDto> {
    return this.readyReadyGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendReadinessResponseDto>): BackendReadinessResponseDto => r.body),
    );
  }

  /** Path part for operation `getFreshnessFreshnessGet()` */
  static readonly GetFreshnessFreshnessGetPath = '/freshness';

  /**
   * Свежесть данных: MV-рефреши и активные сценарии видимых проектов.
   *
   * Для каждого зарегистрированного MV — время последнего успешного рефреша (из `analytics.mv_refresh_log`). Для каждого активного сценария видимого пользователю проекта — последний `calculation_data` Django, флаг `needs_recalculation` и `latest_data_date` (max(date) в P&L).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFreshnessFreshnessGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFreshnessFreshnessGet$Response(
    params?: GetFreshnessFreshnessGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendFreshnessResponseDto>> {
    return getFreshnessFreshnessGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Свежесть данных: MV-рефреши и активные сценарии видимых проектов.
   *
   * Для каждого зарегистрированного MV — время последнего успешного рефреша (из `analytics.mv_refresh_log`). Для каждого активного сценария видимого пользователю проекта — последний `calculation_data` Django, флаг `needs_recalculation` и `latest_data_date` (max(date) в P&L).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFreshnessFreshnessGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFreshnessFreshnessGet(
    params?: GetFreshnessFreshnessGet$Params,
    context?: HttpContext,
  ): Observable<BackendFreshnessResponseDto> {
    return this.getFreshnessFreshnessGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendFreshnessResponseDto>): BackendFreshnessResponseDto => r.body),
    );
  }
}
